/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { apiBindPlayer } from '@/api/gsManage';
import SelectGS from '../modules/selectGS.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'bindRole',
  props: {
    gid: null
  },
  emits: ['ok'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    const formData = ref({
      gs_chairman_id: undefined,
      role_id: '',
      re_role_id: ''
    });
    const formDataRef = ref();
    const validatorRole = (rule, value, callback) => {
      if (!value) {
        callback('请输入角色ID');
      } else {
        if (value !== formData.value.role_id) {
          callback(new Error('两次输入不一致，请检查'));
        }
      }
      callback();
    };
    const rules = reactive({
      gs_chairman_id: [{
        required: true,
        message: '请输入GS名称',
        trigger: 'change'
      }],
      role_id: [{
        required: true,
        message: '请输入角色',
        trigger: 'blur'
      }],
      re_role_id: [{
        required: true,
        validator: validatorRole,
        trigger: 'blur'
      }]
    });
    const dialogVisible = ref(false);
    const handleClose = elForm => {
      if (!elForm) return;
      dialogVisible.value = false;
      elForm.resetFields();
    };
    const show = () => {
      dialogVisible.value = true;
    };
    const handleOk = elForm => {
      if (!elForm) return;
      elForm.validate(async valid => {
        if (!valid) return;
        const res = await apiBindPlayer({
          gs_chairman_id: formData.value.gs_chairman_id,
          role_id: formData.value.role_id.trim(),
          game_id: props.gid
        });
        if (res.code === 0) {
          handleClose(formDataRef.value);
          emits('ok');
        }
      });
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_dialog = __unplugin_components_4;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "绑定玩家",
        width: "600px",
        "before-close": () => handleClose(_unref(formDataRef))
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = () => handleClose(_unref(formDataRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = () => handleOk(_unref(formDataRef)))
        }, {
          default: _withCtx(() => [_createTextVNode(" 确定 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formDataRef",
          ref: formDataRef,
          model: _unref(formData),
          rules: _unref(rules),
          "label-width": "150px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "选择GS",
            prop: "gs_chairman_id"
          }, {
            default: _withCtx(() => [_createVNode(SelectGS, {
              modelValue: _unref(formData).gs_chairman_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).gs_chairman_id = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "输入玩家角色ID",
            prop: "role_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).role_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).role_id = $event),
              placeholder: "输入玩家角色ID",
              minlength: "1",
              maxlength: "50"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "再次输入玩家角色ID",
            prop: "re_role_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).re_role_id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).re_role_id = $event),
              placeholder: "再次输入玩家角色ID",
              minlength: "1",
              maxlength: "50"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "before-close"]);
    };
  }
});